





















































import { store } from "@/store/store";
import Utils from "@/utils/utils";
import DeviceVehicleCard from "@/components/Page/DeviceGraph/DeviceVehicleCard.vue";
import DeviceRemplissageCard from "@/components/Page/DeviceGraph/DeviceRemplissageCard.vue";
import DeviceTensionCard from "@/components/Page/DeviceGraph/DeviceTensionCard.vue";
import DeviceTempCard from "@/components/Page/DeviceGraph/DeviceTempCard.vue";
import DeviceCpuCard from "@/components/Page/DeviceGraph/DeviceCpuCard.vue";
import DeviceMemCard from "@/components/Page/DeviceGraph/DeviceMemCard.vue";
import Vue from "vue";
import { CameraImage } from "@/store/modules/CameraImage/interface";
import { PickStr } from "@/types/types";

export default Vue.extend({
  name: "DeviceGraph",
  components: {
    DeviceVehicleCard,
    DeviceRemplissageCard,
    DeviceTensionCard,
    DeviceTempCard,
    DeviceCpuCard,
    DeviceMemCard
  },
  created() {
    this.camera_images = [
      ...store.getters.CAMERA_IMAGE_ALL_ID.filter(
        (camera_image) => store.getters.CAMERA_IMAGE_BY_ID[camera_image].material === this.device._id
      ).map((camera_image) => store.getters.CAMERA_IMAGE_BY_ID[camera_image])
    ];
    this.max_labels = this.format_data_labels();
    this.type = "days";
    this.data = this.format_data();
  },
  data() {
    return {
      device: store.getters.DEVICE_BY_ID[this.$route.query.deviceId as string],
      camera_images: [] as Array<CameraImage>,
      type: "weeks",
      data: [] as Array<CameraImage>,
      max_labels: [] as Array<string>
    };
  },
  methods: {
    format_data_labels(): Array<string> {
      const labels = [];

      const time_: PickStr<any> = {
        hours: new Date(new Date().setHours(0, 0, 0)),
        days: new Date(new Date(new Date().setHours(0, 0, 0)).setDate(new Date().getDate() - 3)),
        weeks: new Date(new Date(new Date().setHours(0, 0, 0)).setDate(new Date().getDate() - 7))
      };

      const time: Date = time_[this.type];

      while (time < new Date(new Date().setHours(new Date().getHours() - 2))) {
        labels.push(Utils.transformDateToYMDHMS(time));
        time.setHours(time.getHours() + 1);
      }
      return labels;
    },
    format_data(): Array<any> {
      let datas = [];
      for (const label of this.max_labels) {
        const r = this.camera_images.find((camera_image) => {
          return (
            Utils.transformDateToYMDHMS(
              camera_image.d_h_process || Utils.transformDateToHour(new Date(camera_image.date))
            ) === label
          );
        });
        r === undefined ? datas.push({ nb_jpg: NaN, nb_unknown: NaN, d_h_process: label }) : datas.push(r);
      }
      return datas;
    },
    get_datas_content() {
      const index = this.data.findIndex(
        (data_) =>
          Utils.transformDateToYMDHMS(data_.d_h_process || Utils.transformDateToHour(new Date(data_.date))) ===
          this.max_labels[0]
      );
      return this.data.slice(index, this.data.length);
    },
    categoryName() {
      return store.getters.CATEGORY_BY_ID[this.device.category].name;
    },
    tempId() {
      const category = this.categoryName();
      if (category === "Lapi" || category === "Lapi-observer") {
        return ["temp_sim", "temp_rasp"];
      } else {
        return ["temp_sim", "rasp_temp", "pycam_temp"];
      }
    }
  },
  watch: {
    type() {
      this.max_labels = this.format_data_labels();
    }
  }
});
